export * from './sweet-face-terminal-functions-configuration.interface';
